import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getCurrentUserId } from "../../utils/auth";
import { getAdhaarVerified } from "../../utils/auth";

import { FaTrash } from "react-icons/fa";

import "../../css//User/EditProfile.css";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import {
  FaUser,
  FaBirthdayCake,
  FaPhone,
  FaEnvelope,
  FaLock,
  FaPen,
  FaCity,
  FaMapMarkerAlt,
  FaUserFriends,
} from "react-icons/fa";
import { TbFilePencil } from "react-icons/tb";
import { useProfile } from "../../hook/useProfile";
import { toast } from "react-toastify";

export default function EditProfile() {
  const currentUserId = getCurrentUserId();
  const navigate = useNavigate();
  const {
    isProfileInfo,
    updateProfile,
    isLoading,
    isState: contextStates,
  } = useProfile();
  const MyProfileID = isProfileInfo?._id;
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [feedType, setFeedType] = useState("prime");
  const [activeSidebar, setActiveSidebar] = useState("profile");
  const sidebarMenus = getSidebarMenus(currentUserId);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [ageError, setAgeError] = useState("");
  

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    age: "",
    bio: "",
    profession: "",
    gender: "",
    statePublic: "",
    districtPublic: "",
    statePrivate: "",
    districtPrivate: "",
    aadhar: "",
    pan: "",
    password: "",
    isProfileLocked: false,
    isBatch: false,
  });

  const [editPopup, setEditPopup] = useState({
    isOpen: false,
    field: "",
    label: "",
    value: "",
  });

  const openEditPopup = (field, label) => {
    setEditPopup({
      isOpen: true,
      field,
      label,
      value: formData[field] || "",
    });

    if (field.includes("district")) {
      const stateName =
        field === "districtPublic"
          ? formData.statePublic
          : formData.statePrivate;

      const stateObj = contextStates?.find((s) => s.stateName === stateName);
      setDistrictOptions(stateObj?.districts || []);
    }
  };

  const closePopup = () => {
    setEditPopup({ isOpen: false, field: "", label: "", value: "" });
    setDistrictOptions([]);
  };

  const [clearedFields, setClearedFields] = useState([]);

  /* ================= POPUP SAVE (LOCAL ONLY) ================= */

  const handlePopupSave = () => {
    // Age Validation (Only When Editing Age)
    if (editPopup.field === "age") {
      const numericAge = parseInt(editPopup.value, 10);

      if (editPopup.value && numericAge < 18) {
        setAgeError("Age must be 18 or above");
        return;
      }

      if (editPopup.value && numericAge > 120) {
        setAgeError("Age cannot be more than 120");
        return;
      }
      setAgeError("");
    }
    setFormData((prev) => ({
      ...prev,
      [editPopup.field]: editPopup.value,
    }));

    closePopup();
  };


  const handleClearField = (fieldKey) => {                // ✅ Add here
    setClearedFields((prev) => [...prev, fieldKey]);
    setFormData((prev) => ({ ...prev, [fieldKey]: "" }));
  };

  /* ================= FINAL SAVE (API CALL) ================= */

  // const handleFinalSave = async () => {
  //   const payload = new FormData();

  //   // console.log("formData before save:", formData); // ✅ Add this
  //   // console.log("clearedFields:", clearedFields); 

  //   Object.entries(formData).forEach(([key, value]) => {

  //     // console.log(key, "→", value);

  //     if (clearedFields.includes(key)) {
  //       // ✅ User intentionally cleared this field — send empty string
  //       payload.append(key, "");
  //     } else if (value !== "" && value !== null && value !== undefined) {
  //       // ✅ User filled this field — send the value
  //       if (key === "gender") {
  //         payload.append(key, value.toLowerCase().replace(" ", "_"));
  //       } else {
  //         payload.append(key, value);
  //       }
  //     }
  //     // Else: field was never filled — skip it
  //   }); 

  // //   for (let [key, value] of payload.entries()) {
  // //   console.log("Payload →", key, ":", value);
  // // }

  //   try {
  //     await updateProfile(payload);
  //     setClearedFields([]); // ✅ Reset cleared fields after save
  //     toast.success("Profile updated successfully");
  //     navigate(`/my/${MyProfileID}/profile`);
  //   } catch (err) {
  //     console.error("Profile update failed", err);
  //   }
  // };


  const handleFinalSave = async () => {
    const payload = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (clearedFields.includes(key)) {
        // User intentionally cleared field
        payload[key] = "";
      } else if (value !== "" && value !== null && value !== undefined) {
        // User entered a value
        if (key === "gender") {
          payload[key] = value.toLowerCase().replace(" ", "_");
        } else {
          payload[key] = value;
        }
      }
    });

    try {
      await updateProfile(payload);

      setClearedFields([]);

      toast.success("Profile updated successfully");

      navigate(`/my/${MyProfileID}/profile`);
    } catch (err) {
      console.error("Profile update failed", err);

      toast.error(
        err.response?.data?.error ||
        err.message ||
        "Failed to update profile"
      );
    }
  };




  /* ================= LOAD PROFILE DATA ================= */

  useEffect(() => {
    if (isProfileInfo) {
      setFormData({
        fullName: isProfileInfo.fullName || "",
        email: isProfileInfo.email || "",
        phone: isProfileInfo.phone || "",
        age: isProfileInfo.age || "",
        bio: isProfileInfo.bio || "",
        profession: isProfileInfo.profession || "",
        gender: isProfileInfo.gender || "",
        statePublic: isProfileInfo.statePublic || "",
        districtPublic: isProfileInfo.districtPublic || "",
        statePrivate: isProfileInfo.statePrivate || "",
        districtPrivate: isProfileInfo.districtPrivate || "",
        aadhar: isProfileInfo.aadhar || "",
        pan: isProfileInfo.pan || "",
        password: "",
        isProfileLocked: isProfileInfo.isProfileLocked || false,
        isBatch: isProfileInfo.isBatch || false,
      });
    }
  }, [isProfileInfo]);

  /* ================= EDIT NAME LOCK AFTER AADHAR VERIFIED ================= */
  const [isAadharVerified, setIsAadharVerified] = useState(false);

  useEffect(() => {
    const fetchaadharStatus = async () => {
      try {
        const res = await getAdhaarVerified();

        console.log("AADHAAR RESPONSE:", res);

        setIsAadharVerified(res === "VERIFIED");
      } catch (error) {
        console.error("Error fetching KYC status", error);
      }
    };

    fetchaadharStatus();
  }, []);

  /* ================= RESIZE ================= */

  if (!isProfileInfo) return <div>Loading...</div>;

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />

        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}

            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => navigate(item.path)}
            />

            {/* ================= CENTER AREA ================= */}

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="center-area">
                <div className="w-100 pb-5">
                  <div className="personal-details-container">
                    <div className="personal-content-container">
                      <div className="personal-details">
                        <h2>Public Details</h2>
                        <DetailRow
                          label="Full Name"
                          value={formData.fullName}
                          icon={FaUser}
                          onEdit={() => openEditPopup("fullName", "Full Name")}
                          onClear={() => handleClearField("fullName")}  
                          canClear={false}
                          canEdit={!isAadharVerified}
                        />
                        <DetailRow
                          label="Gender"
                          value={formData.gender}
                          icon={FaUserFriends}
                          onEdit={() => openEditPopup("gender", "Gender")}
                          onClear={() => handleClearField("gender")}
                          canClear={false}
                        />
                        <DetailRow
                          label="Email"
                          value={formData.email}
                          icon={FaEnvelope}
                          onEdit={() => openEditPopup("email", "Email")}
                          onClear={() => handleClearField("email")}
                          canClear={false} 
                        />
                        <DetailRow
                          label="Bio"
                          value={formData.bio}
                          icon={TbFilePencil}
                          onEdit={() => openEditPopup("bio", "Bio")}
                          onClear={() => handleClearField("bio")}
                        />
                        <DetailRow
                          label="Profession"
                          value={formData.profession}
                          icon={FaLock}
                          onEdit={() => openEditPopup("profession", "Profession")}
                          onClear={() => handleClearField("profession")}
                        />
                        <DetailRow
                          label="Public State"
                          value={formData.statePublic}
                          icon={FaMapMarkerAlt}
                          onEdit={() => openEditPopup("statePublic", "Public State")}
                          onClear={() => handleClearField("statePublic")} 
                        />
                        <DetailRow
                          label="Public District"
                          value={formData.districtPublic}
                          icon={FaCity}
                          onEdit={() => openEditPopup("districtPublic", "Public District")}
                          onClear={() => handleClearField("districtPublic")}
                        />
                      </div>

                      <div className="personal-details">
                        <h2>Private Details</h2>
                        <DetailRow
                          label="Phone Number"
                          value={formData.phone}
                          icon={FaPhone}
                          onEdit={() => openEditPopup("phone", "Phone Number")}
                          onClear={() => handleClearField("phone")}  
                          canClear={false}
                          canEdit={false}
                        />
                        <DetailRow
                          label="Age"
                          value={formData.age}
                          icon={FaBirthdayCake}
                          onEdit={() => openEditPopup("age", "Age")}
                          onClear={() => handleClearField("age")} 
                          canClear={false}
                        />

                        <DetailRow
                          label="Private State"
                          value={formData.statePrivate}
                          icon={FaMapMarkerAlt}
                          // onEdit={() => openEditPopup("statePrivate", "Private State")}
                          onClear={() => handleClearField("statePrivate")} 
                          canClear={false}
                          canEdit={false}
                        />
                        <DetailRow
                          label="Private District"
                          value={formData.districtPrivate}
                          icon={FaCity}
                          // onEdit={() => openEditPopup("districtPrivate", "Private District")}
                          onClear={() => handleClearField("districtPrivate")}
                          canClear={false}
                          canEdit={false}
                        />

                        <div className="save-my-profile">
                          <button
                            onClick={handleFinalSave}
                            disabled={isLoading}
                          >
                            {isLoading ? "Saving..." : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*============== EDIT POPUP START =============*/}

        {editPopup.isOpen && (
          <div className="popup-overlay">
            <div className="popup-box">
              <h3>Edit {editPopup.label}</h3>

              {editPopup.field.includes("state") ? (
                <select
                  value={editPopup.value}
                  onChange={(e) =>
                    setEditPopup((prev) => ({ ...prev, value: e.target.value }))
                  }
                >
                  <option value="">Select State</option>
                  {contextStates?.map((s, i) => (
                    <option key={i} value={s.stateName}>
                      {s.stateName}
                    </option>
                  ))}
                </select>
              ) : editPopup.field.includes("district") ? (
                <select
                  value={editPopup.value}
                  onChange={(e) =>
                    setEditPopup((prev) => ({ ...prev, value: e.target.value }))
                  }
                >
                  <option value="">Select District</option>
                  {districtOptions.map((d, i) => (
                    <option key={i} value={d}>
                      {d}
                    </option>
                  ))}
                </select>
              ) : editPopup.field.includes("gender") ? (
                <select
                  value={editPopup.value}
                  onChange={(e) =>
                    setEditPopup((prev) => ({ ...prev, value: e.target.value }))
                  }
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              ) : (
                <input
                  type={editPopup.field === "password" ? "password" : "text"}
                  maxLength={editPopup.field && editPopup.field === "phone" ? 10 : undefined}
                  value={editPopup.value}
                  // onChange={(e) =>
                  //   setEditPopup((prev) => ({ ...prev, value: e.target.value }))
                  // }
                  onChange={(e) => {
                    let value = e.target.value;

                    // Full Name Only Characters & Space
                    if (editPopup.field === "fullName") {
                      value = value.replace(/[^a-zA-Z\s]/g, "");
                    }

                    // Phone Only Digits
                    if (editPopup.field === "phone") {
                      value = value.replace(/[^0-9]/g, "");
                    }

                    // Age → Only Digits
                    if (editPopup.field === "age") {
                      value = value.replace(/[^0-9]/g, "").slice(0, 3);
                    }
                    // Email Allow Only Valid Email Characters
                    if (editPopup.field === "email") {
                      // remove unwanted symbols
                      value = value.replace(/[^a-zA-Z0-9@.]/g, "");

                      // prevent multiple @
                      const parts = value.split("@");
                      if (parts.length > 2) {
                        value = parts[0] + "@" + parts[1];
                      }

                      // prevent multiple dots after @
                      const emailParts = value.split("@");
                      if (emailParts[1]) {
                        emailParts[1] = emailParts[1].replace(/\.{2,}/g, ".");
                        value = emailParts.join("@");
                      }
                    }

                    setEditPopup((prev) => ({ ...prev, value }));
                  }}
                />
              )}
              {editPopup.field === "age" && ageError && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "1px" }}>
                  {ageError}
                </p>
              )}

              <div className="popup-actions">
                <button onClick={closePopup}>Cancel</button>
                <button
                  onClick={handlePopupSave}
                  className="popup-action-button"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function DetailRow({ label, value, icon: Icon, onEdit, onClear, canClear = true, canEdit = true }) {
  return (
    <div className="personal-details-content">
      <div className="details-text">
        <div className="details-text2">
          <Icon className="icon-left" />
          <div className="main-personal-details">
            <label>{label}:</label>
            <span>{value || "-"}</span>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          {/* ✅ Show trash icon only if canClear is true AND field has value */}
          {canClear && value && (
            <FaTrash
              className="icon-right text-danger"
              onClick={onClear}
              title={`Clear ${label}`}
            />
          )}

          {canEdit && (
            <FaPen className="icon-right" onClick={onEdit} />
          )}

          {/* <FaPen className="icon-right" onClick={onEdit} /> */}
        </div>
      </div>
    </div>
  );
}
